import { Card, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { EyeFill, PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import AddUser from "./AddCustomer";
import { toast } from "react-toastify";
import ViewCustomer from "./ViewCustomer";

interface PropData {
    data: UserInterface | null
}

export interface UserInterface {
    _id: number
    fullName: string;
    email: string;
    username: string;
    password: string;
    user_type: "ADMIN" | "USER";
    organization?: string;
    otp?: string | null;
    phone?: string | null;
    temp_otp?: string | null;
    image?: string | null;
    type?: string | null;
    isVerified: string; // 'Y' or 'N'
    verificationToken?: string;
    social_type?: string | null;
    socialid?: string | null;
    status: AdminUserStatusEnum;
}

export enum AdminUserStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    DELETED = 'DELETED'
}

export enum OrganizationType {
    ORGANIZATION = 'ORGANIZATION',
    PERSONAL = 'PERSONAL'
}

const columns = [
    {
        id: "title",
        label: "Title",
        minWidth: 170,
        sortable: true,
    },

    {
        id: "type",
        label: "Type",
        minWidth: 170,
        sortable: true,
    },
    // {
    //     id: "downloaded_by",
    //     label: "Downloaded By",
    //     minWidth: 170,
    //     sortable: true,
    // },
    {
        id: "downloaded_on",
        label: "Downloaded On",
        minWidth: 170,
        sortable: true,
    },
    // {
    //     id: "createdAt",
    //     label: "Created Date",
    //     minWidth: 170,
    //     sortable: true,
    // },
    // {
    //     id: "action",
    //     label: "Action",
    //     minWidth: 100,
    //     align: "center" as const,
    // },
];


const Resources = (props: PropData) => {
    const [showAdminBlade, setShowAdminBlade] = useState(false);
    const [leadershipCouncils, setLeadershipCouncils] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<string | null>(null);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [search, setSearch] = useState("");
    const [sortField, setSortField] = useState<string>("createdAt");
    const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
    const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
    const [loading, setLoading] = useState<boolean>(false);
    const sortFieldMap: Record<string, string> = {
        createdAtFormatted: "createdAt",
        createdAt: "createdAt",
        title: "finalItem.title",
        type: "finalItem.itemCategory",
        downloaded_on: "downloaded_on",
    };
    const [userObject, setUserObject] = useState<UserInterface | null>(null)
    const [showCustomerView, setShowCustomerView] = useState(false);

    console.log("propsData", props.data);

    useEffect(() => {
        getOrganizationResourcesList();
    }, [currentPage, sortField, sortOrder]);

    const getOrganizationResourcesList = (keyword: string = "") => {
        setLoading(true);
        const params = new URLSearchParams();
        params.append("page", currentPage.toString());
        params.append("limit", itemsPerPage.toString());

        // Keyword searches
        if (keyword.trim()) {
            params.append("keyword", keyword.trim());
        }

        // Sorting
        params.append("sortField", sortField);
        params.append("sortOrder", sortOrder);

        if (!props?.data?._id) {
            setLoading(false);
            return;
        }
        WebService.getAPI({
            action: `users/get-resource-list/${props.data._id}?${params.toString()}`,
        })
            .then((res: any) => {
                const formattedRows = res?.data?.data.map((item: any) => {
                    return {
                        title: item.finalItem?.title || "-",
                        // type: item.finalItem?.itemCategory || "-",
                        type: HelperService.getResourceTypeLabel(item.finalItem?.itemCategory),
                        downloaded_by: item.user?.fullName || "-",
                        downloaded_on: HelperService.getFormatedDate(item.downloaded_on),
                        createdAt: HelperService.getFormatedDate(item.createdAt),
                    };
                });
                setLeadershipCouncils(formattedRows);
                setTotalCount(res?.data?.pagination?.total);
            })
            .catch((err: any) => {
                console.error("Error fetching organization resources:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleDeleteEvent = (leadershipCouncilId: string) => {
        setLeadershipCouncilToDelete(leadershipCouncilId);
        setShowDeleteModal(true);
    };

    const actionList = (item: any) =>
    (
        <div>
            <PencilFill className="me-3 cursor-pointer" size={16}
                onClick={() => {
                    setShowAdminBlade(true);
                    setUserObject(item);
                }}
                title="Edit"
            />
            <EyeFill className="me-3 cursor-pointer" size={18}
                onClick={() => {
                    setShowCustomerView(true);
                    setUserObject(item);
                }}
                title="View"
            />
        </div>
    );
    return (
        <>
            <AddUser show={showAdminBlade}
                handleClose={() => { setShowAdminBlade(false); getOrganizationResourcesList(); setUserObject(null); }}
                data={userObject}
            />
            <ViewCustomer show={showCustomerView}
                handleClose={() => { setShowCustomerView(false); getOrganizationResourcesList(); setUserObject(null); }}
                data={userObject}
            />
            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onDelete={() => {
                    if (leadershipCouncilToDelete) {
                        WebService.deleteAPI({
                            action: `admin-user/delete-admin-user/${leadershipCouncilToDelete}`,
                        }).then(() => {
                            setShowDeleteModal(false);
                            toast.success("Admin User deleted successfully.");
                            getOrganizationResourcesList();
                        });
                    }
                }}
                message="Are you sure you want to delete ?"
            />
            <div className="card">
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <Form.Label className="label">Search</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="search"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                    getOrganizationResourcesList(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <div>
                            <CustomTableSortable
                                columns={columns}
                                rows={leadershipCouncils}
                                totalCount={totalCount}
                                currentPage={currentPage}
                                pageSize={itemsPerPage}
                                onPageChange={(page) => {
                                    setCurrentPage(page);
                                }}
                                isLoading={loading}
                                sortField={uiSortField}
                                sortOrder={sortOrder}
                                onSortChange={(columnId, order) => {
                                    setUiSortField(columnId);
                                    setSortOrder(order);
                                    const apiField = sortFieldMap[columnId] || "createdAt";
                                    setSortField(apiField);
                                    setCurrentPage(1);
                                    // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Resources;
